// Mock data and API for Color Management
// Based on docs/color-document.yaml

let colors = [
  {
    _id: "1",
    name: "Primary",
    code: "#1976d2",
    description: "Primary brand color",
    component: "header",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    _id: "2",
    name: "Secondary",
    code: "#9c27b0",
    description: "Secondary color",
    component: "footer",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

function listColors(component) {
  if (!component) return colors;
  const comps = Array.isArray(component) ? component : component.split(",");
  return colors.filter((c) => comps.includes(c.component));
}

function createColor(data) {
  const newColor = {
    _id: (Date.now() + Math.random()).toString(),
    ...data,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
  colors.push(newColor);
  return {
    message: "Tạo màu sắc thành công",
    status: "success",
    data: newColor,
  };
}

function updateColor(id, data) {
  const idx = colors.findIndex((c) => c._id === id);
  if (idx === -1) return null;
  colors[idx] = {
    ...colors[idx],
    ...data,
    updatedAt: new Date().toISOString(),
  };
  return {
    message: "Cập nhật thành công",
    status: "success",
    data: colors[idx],
  };
}

function deleteColor(id) {
  const idx = colors.findIndex((c) => c._id === id);
  if (idx === -1) return null;
  colors.splice(idx, 1);
  return { message: "Xóa thành công", status: "success" };
}

function getColorMap(component) {
  const filtered = listColors(component);
  return filtered.reduce((acc, c) => {
    acc[c.name] = c.code;
    return acc;
  }, {});
}

export { listColors, createColor, updateColor, deleteColor, getColorMap };
